const find = require('lodash/fp/find');
const get = require('lodash/fp/get');

class PaymentController {
  constructor(ccTypeMap) {
    this.ccTypeMap = ccTypeMap;
    this.showNumEnding = numEnd => numEnd;
    this.isANumber = val => !Number.isNaN(val);
    this.showDate = (str) => {
      if (this.isANumber(str.month) && this.isANumber(str.year)) {
        return `${parseFloat(str.month)}/${parseFloat(str.year)}`;
      }
      return false;
    };
  }

  static get $inject() {
    return ['ccTypeMap'];
  }

  $onChanges({ ngModel }) {
    this.selectedId = get('currentValue.publicId', ngModel);
  }

  onSelect(newlySelectedPaymentId) {
    const selected = find({ publicId: newlySelectedPaymentId }, this.payments);

    this.onChange({ selected });
  }
}

angular.module('msi.payments.dropdown')
  .controller('PaymentController', PaymentController);

module.exports = PaymentController;
